import React from "react";

interface EventToggleIconProps {
  isOn: boolean;
  className?: string;
}

const EventToggleIcon: React.FC<EventToggleIconProps> = ({ isOn, className }) => {
  if (isOn) {
    return (
      <svg
        className={className}
        width="36"
        height="20"
        viewBox="0 0 36 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <rect width="36" height="20" rx="10" fill="rgba(0, 87, 183, 1)" />
        <circle cx="26" cy="10" r="8" fill="#ffffff" />
      </svg>
    );
  }

  return (
    <svg
      className={className}
      width="36"
      height="20"
      viewBox="0 0 36 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle cx="11" cy="10" r="8" fill="rgba(203, 213, 225, 1)" />
      <circle cx="22" cy="10" r="8" fill="rgba(148, 163, 184, 1)" fillOpacity="0.85" />
    </svg>
  );
};

export default EventToggleIcon;
